/** @jsxImportSource @emotion/react */
import React from 'react';
import { SUPPORT_URL } from 'shared/constants/links';
import * as S from './styles';

interface IStubSupportLinkProps {
  className?: string;
}

function StubSupportLink(props: IStubSupportLinkProps) {
  const { ...rest } = props;

  return (
    <S.SupportLink to={SUPPORT_URL} {...rest}>
      Нужна помощь? Связаться с поддержкой.
    </S.SupportLink>
  );
}

export default StubSupportLink;
